(function ($) {
    const audio = document.querySelector("audio");
    $('.playlist__song:first-child').addClass('active');

    // click song
    $(document).on('click', '.playlist__song', function (e){
        e.preventDefault();
        var _this = $(this);
        $('.playlist__song').removeClass('active')
        _this.addClass('active')
        var url = _this.attr('data-url');
        let register = _this.attr('data-register');
        let is4g = _this.attr('data-is4g');
        if(register == 0 || !is4g){
            var play = $('.music-player-card .track__audio').attr('src', url);
            audio.play(play);
        }else{
            $('.modal-reg-package-music').modal('show');
        }

    });

    // click new-release
    // $(document).on('click', '.section-new-release .new-release .list-items .info a', function (e){
    //     e.preventDefault();
    //     $(this).addClass('active')
    // });
})(jQuery);
